import { GridColDef, GridValidRowModel } from '@mui/x-data-grid-premium'

/**
 * Adapt a list-style `GridColDef` for use in a single-row, read-only
 * detail-page "Information" grid: stretch to fill the width and disable
 * sorting / column menu / editing (all meaningless for one row).
 *
 * Pass `overrides` to tweak the reused column for this context, e.g.
 * `{ headerName: '...' }` when the detail label differs from the list, or
 * `{ renderCell: undefined }` to drop a self-link the list column adds
 * (an entity should not link to its own detail page).
 */
export const toInfoColumn = <T extends GridValidRowModel>(column: GridColDef<T>, overrides?: Partial<GridColDef<T>>): GridColDef<T> => ({
  ...column,
  flex: 1,
  sortable: false,
  disableColumnMenu: true,
  editable: false,
  ...overrides
})
